/**
 * Вспомогательная функция для отправки email уведомлений
 * Вызывает Netlify Function send-email
 */

const NETLIFY_FUNCTIONS = import.meta.env.VITE_NETLIFY_FUNCTIONS_URL || ''

export async function sendEmailNotification(type, userId, data = {}) {
  try {
    const url = NETLIFY_FUNCTIONS 
      ? `${NETLIFY_FUNCTIONS}/send-email` 
      : '/.netlify/functions/send-email'
    
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type, userId, ...data })
    })

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      console.error(`[sendEmailNotification] Failed to send ${type} email:`, errorData)
      return false
    }

    const result = await response.json().catch(() => ({}))
    console.log(`[sendEmailNotification] ✅ Email ${type} sent:`, result.sent)
    return result.sent === true
  } catch (error) {
    console.error(`[sendEmailNotification] Error sending ${type} email:`, error)
    return false
  }
}
